import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'
import axios from 'axios'
// 公共组件 侧边栏 顶部 底部
import Main from '@/components/Main'
//登录页
import login from '@/login/login.vue'
import NotFound from '@/publicComponents/notFound.vue'
import globalPath from '@/assets/script/globalPath'
import common from '@/assets/script/common.js'
// LoginSuccessful
Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/loginSuccess',
      name: 'loginSuccess',
      component:  (resolve) => require (['@/login/loginSuccess'],resolve)
    },
    {
      path: '/register',
      name: 'register',
      component:  (resolve) => require (['@/register/index'],resolve)
    },
    {
      path: '/retrievePassWord',
      name: 'retrievePassWord',
      component:  (resolve) => require (['@/retrievePassWord/index'],resolve)
    },
    {
      path: '/',
      component: Main,
      meta: {
        requireAuth: true
      },
      children: [{
          path: "/",
          redirect: '/home'
        },]
    },
  ]
});
let router_lise = [];

// 未登录路由拦截
router.beforeEach((to,from,next)=>{
  let isLogin = common.getCookie('tibiot-company-card-web'); // 获取token
  //路由设置
  if (isLogin) {
    if (router_lise.length == 0) {
      if(to.path === '/loginSuccess' && to.query.authToken){
        document.cookie = 'CardPageKey=true;path=/;domain=tibiot.com;'
        document.cookie = "tibiot-company-card-web="+ to.query.authToken +";path=/;"
      }
      console.log(to.path)
      getRouters(to,from, next);
    } else {
      if (to.path == '/404') {
        next({path: '/home'})
      } else {
        next()
      }
    }
  }else {
    if (to.path === '/login' || to.path === '/loginSuccess'|| to.path === '/register' || to.path === '/retrievePassWord') {
      router_lise = [];
      next();
    } else {
      router_lise = [];
      next({path: "/login"})
    }
  }
  
  //判断是否login页面
  if (to.fullPath != '/login') {
    //获取面包屑
    getCrumbs(to);
    // //获取当前页面的按钮权限
    getMuneBtn(to);
  }
});
router.onError((error) => {
  console.log('error:'+ error.message); 
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    window.location.reload();
  }else{
    console.log(error)
  }
});

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
//获取当前页面的按钮权限
function getMuneBtn(to){
  if (to.meta.index) { //当前菜单的id;
    axios({
      method: 'post',
      url: globalPath.globalPath.api + 'sysMenu/getSysMenuBtnRole',
      data: {menuId: to.meta.index},
      heads : {
        'content-type' : 'application/json'
      }
    })
    .then(function (res) {
      if (res.data.code == 200) {
        store.commit('setButtons', res.data.data);//存储页面的按钮
      }
    })
    .catch(() => console.log('promise catch err'));
  }
}
//获取面包屑
function getCrumbs(to){
  let crumbsList = store.state.crumbsArr; //储存面包屑
  let arrmenu = store.state.menu;
  let MbxArrs=[];
  let flog = true;
  for(let i=0; i < arrmenu.length; i++){
    let URL = arrmenu[i].menuUrl;
    if(URL == to.path){
        MbxArrs[0]= {
          name:arrmenu[i].menuName,
          url:URL
        };
        flog = false;
      break;
    }else{
        if(arrmenu[i].children){
            for(let j=0; j < arrmenu[i].children.length; j++){
                let TwoURL = arrmenu[i].children[j].menuUrl;
                if(TwoURL.substr(TwoURL.lastIndexOf('/')) == to.path){
                  MbxArrs[0] = {
                    name: arrmenu[i].menuName,
                    url: TwoURL.substr(TwoURL.lastIndexOf('/'))
                  };
                  MbxArrs[1] = {
                    name: arrmenu[i].children[j].menuName,
                    url:TwoURL.substr(TwoURL.lastIndexOf('/'))
                  };
                  flog = false;
                  break;
                }
            }
        }
    }
  }
  if (flog) { //判断路由不再菜单中的路由
    let jumpMenuArr = {
      url:to.fullPath,
      name:to.meta.name
    } , keys = [],identical = 0;
    //判断路由是否存在于面包屑中
    for(let i = 0; i< crumbsList.length; i++){ 
      keys.push(crumbsList[i].url)
    }
    for(let j = 0; j < keys.length; j++){
      if(keys[j] == jumpMenuArr.url){
        identical = j;
      }
    }
    if(identical != 0){  //路由是存在于面包屑中
      crumbsList = crumbsList.slice(0,identical+1);
    }else{
      if(crumbsList[0].name != '首页'){
        crumbsList.push(jumpMenuArr);
      }
    }
    store.commit('setCrumbsArr', crumbsList);
  } else {
    store.commit('setCrumbsArr',MbxArrs);
  }
}
//获取路由
function getRouters(to,from, next){
  router_lise = [];
  axios({
    method: 'post',
    url: globalPath.globalPath.api + 'sysMenu/getSysMenuRoute',
    heads : {
      'content-type' : 'application/json'
    }
  })
  .then(function (res) {
      if(res.data.code == 200 && res.data.data.length != 0){
        router_lise = addDynamicRoutes(res.data.data);
        router.options.routes[4].children = router_lise;
        router.options.routes[5] = {path:'/404', name:'404', component: NotFound};
        router.options.routes[6] = {path: '*', redirect: '/404'};
        router.matcher = new Router().matcher;
        // router.addRoutes(router.options.routes);
        router.addRoutes(router.options.routes);
        console.log(from.path);
        if(from.path == '/login' || from.path == '/'){
          next({path: "/home"});
        }else{
          next({...to});
        }
      }else{
        if (to.path === '/login') {
          next()
        } else {
          next({path: "/login"})
        }
      }
  }).catch(function (err) {
    console.log(err)
    if (to.path === '/login') {
      next()
    } else {
      next({path: "/login"})
    }
  })
}
//整理路由格式
function addDynamicRoutes (menuList = [], routes = []) {
  for(var i = 0; i < menuList.length; i++){
    if(menuList[i].menuUrl){
      let url = menuList[i].menuUrl;
      let route = {
        path: url.substr(url.lastIndexOf('/')),
        name: url.substr(url.lastIndexOf('/')+1),
        component:  (resolve) => require([`@/views${url}`],resolve),
        meta: {
          index : menuList[i].id,
          name : menuList[i].menuName
        }
      };
      routes.push(route);
    }
  }
  routes.push({
    path:"/fileDownloadMag",
    name:'fileDownloadMag',
    component:  (resolve) => require (['@/views/fileDownloadMag'],resolve),
    meta: {
      index : 40,
      name : '文件下载中心'
    }
  });
  routes.push({
    path:"/personalInfo",
    name:'personalInfo',
    component:  (resolve) => require (['@/views/personalInfo'],resolve),
    meta: {
      index : 167,
      name : '个人中心'
    }
  })
  return routes
}


export default router



// WEBPACK FOOTER //
// ./src/router/index.js